import BlankChest from './blank_chest.png';
import GemChest from './gem_chest.png';
import CommonChest from './common_chest.png';
import RareChest from './rare_chest.png';
import MythicChest from './mythic_chest.png';

import GemChestBox from './gem_chest_box.png';
import CommonChestBox from './common_chest_box.png';
import RareChestBox from './rare_chest_box.png';
import MythicChestBox from './mythic_chest_box.png';

export default {
  BlankChest,
  GemChest,
  CommonChest,
  RareChest,
  MythicChest,

  GemChestBox,
  CommonChestBox,
  RareChestBox,
  MythicChestBox
};

const chestBoxes = {
  'common': CommonChestBox,
  'rare': RareChestBox,
  'mythic': MythicChestBox,
  'gem': GemChestBox
};

export const getChestBoxAsset = (rarity) => {
  return chestBoxes[rarity.toLowerCase()];
};
